module.exports = __webpack_public_path__ + "media/luxury-2026/floor-kitchen-cb038b1a.jpg";